module.exports = __webpack_public_path__ + "img/full6-min.81d28ca5.png";